export default {"src":"/_next/static/media/loader-white.1e6a998a.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};